import { types } from '../types/types';

// Dispatch set Searcher
export const setSearcher = (data) => ({
	type: types.setSearcher,
	payload: data,
});

// Dispatch clean Searcher
export const cleanSearcher = () => ({
	type: types.cleanSearcher,
});
